module.exports = __webpack_public_path__ + "static/media/Compass-Lease-1920x1080-2.2417ebe0.png";